import { render, staticRenderFns } from "./TipTransactions.vue?vue&type=template&id=57e4eca2&"
import script from "./TipTransactions.vue?vue&type=script&lang=js&"
export * from "./TipTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports